







































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import FileInput from '@/app/ui/components/FileInput/index.vue'
import Tooltip from '@/app/ui/components/Tooltip/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import ModalSuccess from '../components/ModalSuccess/index.vue'
import CloseCircle from '@/app/ui/assets/close_circle_alt.vue'
import controller from '@/app/ui/controllers/CategorySectionController'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, ValidationRule } from 'vuelidate/lib/validators'
import { EventBusConstants, Utils } from '@/app/infrastructures/misc'
import { CategorySection } from '@/domain/entities/CategorySection'
import MultiselectV2 from '@/app/ui/components/MultiselectV2/index.vue'

interface DropDownInterface {
  value: number
  label: string
}

interface Form {
  categoryName: string
  bannerHomepage: Blob | File | null
  bannerDetail: Blob | File | null
  products: DropDownInterface[]
}

interface ValidationsInterface {
  form: {
    categoryName: {
      required: () => ValidationRule
    },
    products: {
      required: () => ValidationRule
    }
  }
}

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    TextInput,
    FileInput,
    Tooltip,
    CloseCircle,
    Modal,
    ModalSuccess,
    LoadingOverlay,
    MultiselectV2
  },
})
export default class CategorySectionUpdatePage extends Vue {
  confirmationModal = false
  successModal = false
  enableTooltip = true
  preview = {
    bannerHomepage: '',
    bannerDetail: '',
  }
  controller = controller

  form: Form = {
    categoryName: '',
    bannerHomepage: null,
    bannerDetail: null,
    products: [],
  }

  created(): void {
    controller.getCategorySectionDetail(Number(this.$route.params.categoryId))

    this.fetchProducts('')
  }

  get categorySectionDetail(): CategorySection {
    return controller.categorySectionDetail
  }

  @Watch('controller.statusEditCategorySection')
  onStatusEditCategorySectionChanged(status: string): void {
    if (status !== '' && status === EventBusConstants.UPDATE_CATEGORY_SECTION_SUCCESS) {
      this.successModal = true
    }
    controller.setStatusEditCategorySection('')
  }

  @Watch('categorySectionDetail')
  updateForm(categorySectionDetail: CategorySection): void {
    this.form = {
      categoryName: <string>categorySectionDetail.categoryName,
      products: <DropDownInterface[]>categorySectionDetail.products?.map(product => ({
        value: product.productId,
        label: `${product.productName} - ${product.merchantName}`,
      })),
      bannerDetail: null,
      bannerHomepage: null,
    }

    this.preview = {
      bannerHomepage: <string>categorySectionDetail.bannerHomepageImage,
      bannerDetail: <string>categorySectionDetail.bannerDetailImage,
    }
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  get productOptions(): DropDownInterface[] {
    return controller.productDropdown.map(product => ({
      value: <number>product.productId,
      label: `${product.productName} - ${product.merchantName}`,
    }))
  }

  get isProductLoading(): boolean {
    return controller.isProductLoading
  }

  private changeBannerHomepage(file: File): void {
    this.form.bannerHomepage = file
  }

  private changeBannerDetail(file: File): void {
    this.form.bannerDetail = file
  }

  @Validations()
  validations(): ValidationsInterface {
    return {
      form: {
        categoryName: { required },
        products: {
          required,
        },
      },
    }
  }

  private fetchProducts(search: string): void {
    controller.getProductDropdown({ limit: 500, search })
  }

  private productSearch = Utils.debounce((search: string): void => {
    this.fetchProducts(search)
  }, 500)

  private updateCategorySection(): void {
    controller.updateCategorySection({
      id: Number(this.$route.params.categoryId),
      categoryName: this.form.categoryName,
      bannerHomepageImage: this.form.bannerHomepage,
      bannerDetailImage: this.form.bannerDetail,
      products: this.form.products.map(product => product.value),
    })
  }

  private onCloseSuccessModal(): void {
    this.successModal = false
    this.$router.push({ name: 'HomePageCategorySectionList' })
  }

  beforeDestroy(): void {
    controller.setStatusEditCategorySection('')
  }
}
